// extracted by mini-css-extract-plugin
module.exports = {"wrap_div":"Shop_wrap_div__3QbWT","banner_div":"Shop_banner_div__2fNo3"};